export function getUrlAgreeAndRefuseInitLoan(status, isRefuse) {
    let url;
    switch (status) {
        case 'TG':
            url =
                !isRefuse ?
                    '/appapv/guaranteeTransferPA.action' :
                    '/appapv/guaranteeTransferRejectBorrowerPA.action';
            break;
        case 'CoTG':
            url = !isRefuse ?
                '/appapv/guaranteeTransferConfirmationPA.action' :
                '/appapv/guaranteeTransferConfirmationRejectPA.action';
            break;
        case 'TT':
            url =
                !isRefuse ?
                    '/appapv/titleTransferPA.action' :
                    '/appapv/titleTransferRejectPA.action';
            break;
        case 'CoTT':
            url =
                !isRefuse ?
                    '/appapv/titleTransferConfirmationPA.action' :
                    '/appapv/titleTransferConfirmationRejectPA.action';
            break;
        case 'RG':
            url =
                !isRefuse ?
                    '/appapv/guaranteeReturnPA.action' :
                    '/appapv/guaranteeReturnRejectPA.action';
            break;
        case 'CoRG':
            url =
                !isRefuse ?
                    '/appapv/guaranteeReturnConfirmationPA.action' :
                    '/appapv/guaranteeReturnConfirmationRejectPA.action';
            break;
        default:
            url = '';
            break;
    }

    return url;
}

export function getUrlAgreeAndRefuseExcessLoan(status, isRefuse) {
    let url;
    switch (status) {
        case 'RG':
            url =
                !isRefuse ?
                    '/appapv/guaranteeReturnE.action' :
                    '/appapv/guaranteeReturnRejectE.action';
            break;
        case 'CoRG':
            url =
                !isRefuse ?
                    '/appapv/guaranteeReturnConfirmationE.action' :
                    '/appapv/guaranteeReturnConfirmationRejectE.action';
            break;
        default:
            url = '';
            break;
    }

    return url;
}

export function getUrlAgreeAndRefuseMarginCallLoan(status, isRefuse) {
    let url;
    switch (status) {
        case 'TG':
            url = !isRefuse ?
                '/appapv/guaranteeTransferLl.action' :
                '/appapv/guaranteeTransferRejectLl.action';
            break;
        case 'CoTG':
            url =
                !isRefuse ?
                    '/appapv/guaranteeTransferConfirmationLl.action' :
                    '/appapv/guaranteeTransferConfirmationRejectLl.action';
            break;
        default:
            url = '';
            break;
    }

    return url;
}

export function getUrlAgreeAndRefuseMaturity(status, isRefuse) {
    let url;
    switch (status) {
        case 'V':
        case 'VA':
        case 'RT':
            url =
                !isRefuse ?
                    '/appapv/titlesTransferV.action' :
                    '/appapv/titlesTransferConfirmationRejectV.action';
            break;
        case 'CoRT':
            url =
                !isRefuse ?
                    '/appapv/titlesTransferConfirmationV.action' :
                    '/appapv/titlesTransferConfirmationRejectV.action';
            break;
        case 'RG':
            url =
                !isRefuse ?
                    '/appapv/guaranteeReturnV.action' :
                    '/appapv/guaranteeReturnRejectV.action';
            break;
        case 'CoRG':
            url =
                !isRefuse ?
                    '/appapv/guaranteeReturnConfirmationV.action' :
                    '/appapv/guaranteeReturnConfirmationRejectV.action';
            break;
        default:
            url = '';
            break;
    }

    return url;
}

export function getUrlAgreeAndRefuseGuaranteeReplacement(status, isRefuse) {
    let url;
    switch (status) {
        case 'TG':
            url =
                !isRefuse ?
                    '/appapv/guaranteeTransferS.action' :
                    '/appapv/guaranteeTransferRejectS.action';
            break;
        case 'CoTG':
            url =
                !isRefuse ?
                    '/appapv/guaranteeTransferConfirmationS.action' :
                    '/appapv/guaranteeTransferConfirmationRejectS.action';
            break;
        case 'RG':
            url =
                !isRefuse ?
                    '/appapv/guaranteeReturnS.action' :
                    '/appapv/guaranteeReturnRejectS.action';
            break;
        case 'CoRG':
            url =
                !isRefuse ?
                    '/appapv/guaranteeReturnConfirmationS.action' :
                    '/appapv/guaranteeReturnConfirmationRejectS.action';
            break;
        default:
            url = '';
            break;
    }

    return url;
}

export function getUrlAgreeAndRefuseExtensionLoan(status, isRefuse) {
    let url;
    switch (status) {
        case 'TP':
            url =
                !isRefuse ?
                    '/appapv/rewardTransferPr.action' :
                    '/appapv/rewardTransferRejectPr.action';
            break;
        case 'CoTP':
            url = !isRefuse ?
                '/appapv/rewardTransferConfirmationPr.action' :
                '/appapv/rewardTransferConfirmationRejectPr.action';
            break;
        case 'TG':
            url =
                !isRefuse ?
                    '/appapv/guaranteeTransferPr.action' :
                    '/appapv/guaranteeTransferRejectPr.action';
            break;
        case 'CoTG':
            url =
                !isRefuse ?
                    '/appapv/guaranteeTransferConfirmationPr.action' :
                    '/appapv/guaranteeTransferConfirmationRejectPr.action';
            break;
        case 'RG':
            url =
                !isRefuse ?
                    '/appapv/guaranteeReturnPr.action' :
                    '/appapv/guaranteeReturnRejectPr.action';
            break;
        case 'CoRG':
            url =
                !isRefuse ?
                    '/appapv/guaranteeReturnConfirmationPr.action' :
                    '/appapv/guaranteeReturnConfirmationRejectPr.action';
            break;

        default:
            url = '';
            break;
    }

    return url;
}